import ModelGroup from './ModelGroup'
import Model from './Model'
import EquipmentGraphics from './EquipmentGraphics'
import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import * as _ from "lodash";
export class FountainLineItem extends BaseLineItemEntity{
    ID?: number;
    ModelGroupID?: number;
    ModelGroup?: ModelGroup;
    ModelID?: number;
    Model?: Model;
    EquipmentGraphicsID?: number;
    EquipmentGraphics?: EquipmentGraphics;
    EquipmentLocation: string;
    NumberOfUnits: string;
    MaterialNumber: string;
    CONAModelGroup: string;

    constructor() {
        super();
        this.ModelGroup = new ModelGroup(); 
        this.Model = new Model();
    }
    CloneShallow(): FountainLineItem{
        var newItem:FountainLineItem = _.clone(this);
        newItem.ModelGroup = null;
        newItem.Model = null;
        return newItem;
    }
}

export default FountainLineItem;